import axios from 'axios';
import { URLS } from "./URLS";

export const updateUser = async (data) => {
  // axios.defaults.headers['Authorization'] =  `Bearer ${data.access_token}`;
  return axios.put(URLS.UPDATE_USER, data)
    .then(p => p.data);
}
export const supportRequest = (data) => axios.post(URLS.SUPPORT, data);